/* eslint-disable no-undef */
const DEBUG = process.env.NODE_ENV === "development";

function mctapihost(): string {
  if (DEBUG) {
    return "//localhost:8080";
  }
  if (window.location.hostname.includes("s3-website")) {
    return "//test.medicare.gov";
  }
  return "";
}

const FE_VERSION: string = process.env.REACT_APP_RELEASE_VERSION || "Unknown";

const MCTAPI_PATH: string = DEBUG ? "" : "/api/v1/data/plan-compare";
const MCTAPI_URI: string = process.env.REACT_APP_MCTAPI_URI
  ? process.env.REACT_APP_MCTAPI_URI
  : `${mctapihost()}${MCTAPI_PATH}`;
const USE_LOCAL_PROXY = process.env.REACT_APP_USE_LOCAL_PROXY || false;

const ANON_ENROLL_BASE_URL =
  process.env.REACT_APP_ANON_ENROLL_BASE_URL ||
  "https://test.enrollmentcenter.medicare.gov";

export const USER_INACTIVITY_TIMEOUT_IN_MS = process.env
  .REACT_APP_USER_INACTIVITY_TIMEOUT_IN_MS
  ? parseInt(process.env.REACT_APP_USER_INACTIVITY_TIMEOUT_IN_MS)
  : 1000 * 60 * 15; // default 15 minutes
export const USER_LOGOUT_TIMEOUT_IN_MS = process.env
  .REACT_APP_USER_LOGOUT_TIMEOUT_IN_MS
  ? parseInt(process.env.REACT_APP_USER_LOGOUT_TIMEOUT_IN_MS)
  : 1000 * 60 * 5; // default 5 minutes

declare global {
  interface Window {
    config: object;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    newrelic: any;
  }
}

export const config = (window.config = {
  DEBUG,
  MCTAPI_URI,
  ANON_ENROLL_BASE_URL,
  USE_LOCAL_PROXY,
  FE_VERSION,
});
